<template>
  <div
    class="relative h-full w-auto bg-no-repeat bg-center bg-contain"
    :style="{ backgroundImage: 'url(' + logo + ')' }"
  ></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      logo: 'shared/getLogo',
    }),
  },
}
</script>
